import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadAnswers } from '../../actions/answers/loadAnswers';
import { AnswerList } from '../../components/AnswerList';
import { WideButton } from '../../components/WideButton';
import { getReviewById } from '../../selectors/reviews';
import { AnswerItemContainer } from '../AnswerItem';

interface IAnswerListContainerProps {
  reviewId: string;
  inPopup?: boolean;
}

export function AnswerListContainer({ reviewId, inPopup }: IAnswerListContainerProps) {
  const dispatch = useDispatch();
  const { answers, hasMoreAnswers, answersPage } = useSelector(getReviewById(reviewId));

  const onLoadMoreClick = React.useCallback(() => {
    dispatch(
      loadAnswers({
        reviewId,
        page: answersPage + 1,
      }),
    );
  }, [dispatch, reviewId, answersPage]);

  return (
    <AnswerList
      more={
        hasMoreAnswers && (
          <WideButton testId="MoreAnswers" onClick={onLoadMoreClick}>
            Показать ещё
          </WideButton>
        )
      }
    >
      {answers.map(id => (
        <AnswerItemContainer id={id} key={id} inPopup={inPopup} />
      ))}
    </AnswerList>
  );
}
